import _ from 'lodash';
import { useEffect, useState } from 'react';
import {
  usePostUploadLogoPicture, usePostRemoveLogoPicture, usePutUpdateCompany,
} from '../../../../../services/lwadmin/company/company-service';

export default function useSaveBrand() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [complete, setComplete] = useState(false);
  const [company, setCompany] = useState({ dirty: false });

  const [uploadState, upload] = usePostUploadLogoPicture();
  const [rmState, remove] = usePostRemoveLogoPicture();
  const [updateState, update] = usePutUpdateCompany();

  useEffect(() => {
    const combined = uploadState.loading || rmState.loading || updateState.loading;
    setLoading(!!combined);
  }, [uploadState.loading, rmState.loading, updateState.loading]);

  const save = async (oldCompany, logo, color) => {
    setComplete(false);
    const logoChanged = oldCompany.logoPictureUrl !== logo;
    const colorChanged = oldCompany.logoColor !== color;

    if (!(logoChanged || colorChanged)) {
      setTimeout(() => setComplete(true), 0);
      return;
    }

    const calls = [];
    const c = { ...oldCompany, dirty: true };

    if (logoChanged) {
      if (logo) {
        // We cannot update the `logoPictureUrl` here. See the responses check
        // below when response is available.
        const response = await fetch(logo.content);
        const blob = await response.blob();
        calls.push(upload(oldCompany.id, blob, logo.path));
      } else {
        c.logoPictureUrl = null;
        calls.push(remove(oldCompany.id));
      }
    }

    if (colorChanged) {
      c.logoColor = color;
      calls.push(update({ ...oldCompany, logoColor: color }));
    }

    const responses = await Promise.all(calls);
    if (responses.every(r => [200, 204].indexOf(_.get(r, 'status')) >= 0)) {
      // upload call is always the first element of the `calls` array, if exists.
      logoChanged && logo && (c.logoPictureUrl = _.get(responses[0], 'data.logoPictureUrl', null));
      setCompany(c);
      setComplete(true);
    } else {
      setError('Error saving company brand');
    }
  };

  return [
    {
      loading, complete, company, error,
    },
    save,
  ];
}
